import React, { useState, KeyboardEvent } from 'react';
import { getService } from '@Client/runner.hooks/useService';
import { STATE_MAPPINGS } from '@Shared.Angular/@types/stateMappings';

export const UserMenuSearch = () => {
  const $state = getService('$state');
  const $location = getService('$location');
  const $window = getService('$window');

  const [searchTerm, setSearchTerm] = useState('');

  const searchForTerm = () => {
    if (searchTerm) {
      $state.go(STATE_MAPPINGS.search, { term: searchTerm });
    }
  };

  const onKeyPressed = (keyEvent: KeyboardEvent<HTMLInputElement>) => {
    if (keyEvent.key === 'Enter') {
      searchForTerm();
    }
    keyEvent.stopPropagation();
  };

  const resetSearchInput = () => {
    if (!searchTerm) return;
    navigateBack();
  };

  const navigateBack = () => {
    if ($location.url().includes('/search?term=')) {
      $window.history.back();
      setTimeout(navigateBack, 10);
    } else {
      setSearchTerm('');
    }
  };

  return (
    <div className="user-menu-search">
      <i
        className="action-icon fa-light fa-magnifying-glass"
        onClick={searchForTerm}
      />
      <input
        type="text"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        onKeyDown={onKeyPressed}
        className="text"
        placeholder="Search in progress workflows by flow ID or subject"
      />
      {searchTerm && (
        <i
          className="fa-light fa-times"
          onClick={resetSearchInput}
          title="Clear"
        />
      )}
    </div>
  );
};
